<template>
  <div class="academy-addedit-wrap">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="ruleForm"
    >
      <el-form-item label="项目名称：" prop="projectName">
        <el-tooltip
          effect="dark"
          :content="ruleForm.projectName"
          placement="top"
        >
          <el-input v-model="ruleForm.projectName" disabled />
        </el-tooltip>
      </el-form-item>
      <el-form-item label="接单企业：" prop="enterpriseName">
        <el-input v-model="ruleForm.enterpriseName" disabled />
      </el-form-item>
      <el-form-item label="调研问卷：" prop="enterpriseName">
        <el-button
          class="preview"
          @click="preview"
          :disabled="!this.ruleForm.questionnaireId"
        >
          问卷预览
        </el-button>
        <br />
        <el-input
          v-model="ruleForm.title"
          disabled
          style="margin-bottom:20px;"
        />
        <br />
      </el-form-item>
      <el-form-item
        class="input-width"
        label="项目结算单价（税前）："
        prop="price"
        :disabled="ifDisable"
      >
        <el-input
          class="yuan"
          v-model="ruleForm.price"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <!--      todo 添加税率字段,匹配对应的验证器 -->
      <el-form-item class="input-width" label="税率：" prop="contractScale">
        <el-input
          class="percentage"
          :disabled="ifDisable"
          v-model="ruleForm.contractScale"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="input-width"
        label="总任务量："
        prop="taskSum"
        :disabled="ifDisable"
      >
        <el-input
          v-model="ruleForm.taskSum"
          :disabled="ifDisable"
          maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item class="button-margin-top" :disabled="ifDisable">
        <el-button
          type="primary"
          @click="submitForm('ruleForm', 0)"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="db"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          {{ isConfirm ? '已确认' : '确认' }}
        </el-button>
        <next-project-btn :info="ruleForm" :submitFn="db"></next-project-btn>
        <!-- <el-button type="primary" @click="resetForm('ruleForm')">取消</el-button> -->
      </el-form-item>
    </el-form>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="1000px">
      <div class="preview1">
        <iframe
          id="iframe"
          :src="ifrSrc"
          frameborder="0"
          scrolling="no"
          v-if="dialogVisible"
          @load="iframeLoad"
          width="375px"
          :height="ifrHeight"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Config from '@/config/index';
import { btLoading } from '@/Mixin/btLoading';
/**
 * dbCon
 * setLocalProjectStatus db (methods)
 * isConfirm ifDisable (computed)
 *  */
import { dbCon } from '@/Mixin/doubleConfirm';
import { project } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import { moneyComplete, moneyInt } from '@/tools/money';
import { priceFilter, isInteger, checkTax } from '@/tools/formCheck';
import Clipboard from 'clipboard';
import nextProjectBtn from '@/components/Judge/NextProjectBtn.vue';
export default {
  mixins: [btLoading, dbCon],
  data() {
    const checkTransmitList = (rule, value, callback) => {
      if (value[0] == '') {
        callback(new Error('传递信息不能为空'));
      } else {
        callback();
      }
    };
    const checkFeedbackList = (rule, value, callback) => {
      if (value[0] == '') {
        callback(new Error('传递信息不能为空'));
      } else {
        callback();
      }
    };
    return {
      domain: '',
      fullDomain: 'saas-crm-wx.jimijiayuan.cn',
      dialogVisible: false,
      ifrSrc: '',
      ifrHeight: '',
      ruleForm: {
        projectName: '',
        bgUrl: '',
        price: '',
        taskSum: '',
        enterpriseName: '',
        id: '',
        projectStatus: '',
        contractScale: null,
        title: '',
        url: ''
      },
      // 校验
      rules: {
        price: [
          {
            validator: priceFilter,
            trigger: 'blur',
            required: true
          }
        ],
        enterpriseName: [
          {
            trigger: 'blur',
            required: true
          }
        ],
        taskSum: [
          {
            required: true,
            validator: isInteger,
            trigger: 'blur'
          }
        ],
        enterpriseId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          }
        ],
        projectName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        bgUrl: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'blur'
          }
        ],
        contractScale: [
          {
            required: true,
            validator: checkTax,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: {
    nextProjectBtn,
    dicSelect,
    UploadImgOne
  },
  methods: {
    setDomain() {
      let hostname = window.location.hostname;
      let len = 0;
      if (!hostname.includes('192')) {
        hostname = hostname.split('.');
        len = hostname.length;
        hostname = `${hostname[len - 2]}.${hostname[len - 1]}`;
      }
      return hostname;
    },
    iframeLoad() {
      this.$nextTick(_ => {
        let ifrDom = document.getElementById('iframe');
        setTimeout(_ => {
          this.ifrHeight =
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        }, 1500);
      });
    },
    preview() {
      //预览
      this.ifrSrc = `${Config.iframeUrl}/html/index.html?t=1#/survey?projectId=${this.ruleForm.id}&projectType=${localStorage.projectType}&userId=4&previewFlag=2&platformType=jiafang`;
      this.dialogVisible = true;
    },
    copy() {
      //复制链接
      const clipboard = new Clipboard('.copyBtn');
      clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$message({
          message: '复制失败',
          type: 'warning'
        });
        clipboard.destroy();
      });
    },
    waitPicDone(v) {
      this.ruleForm.bgUrl = v;
    },
    resetForm(formName) {
      this.ruleForm.projectStatus = !(type === 0);
    },
    submitForm(formName, type) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 改变按钮状态
            // 混合对象 格式化数据
            let data = Object.assign({}, this.ruleForm);
            data.price = moneyComplete(data.price);
            data.type = type;
            project
              .yshAddUpdateDcwj(data)
              .then(res => {
                this.$notify({
                  title: '成功',
                  message: type === 0 ? '保存成功' : '提交成功',
                  type: 'success'
                });
                resolve('submit_success');
                this.setLocalProjectStatus(type);
              })
              .catch(() => {
                reject('submit_error');
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    }
  },
  computed: {},
  watch: {
    'ruleForm.contractScale'(value) {
      if (/\d+\.\d{3,}$/g.test('' + value)) {
        this.ruleForm.contractScale = Number(value).toFixed(2);
      }
      if (/\s/g.test(`${value}`)) {
        this.ruleForm.contractScale = `${value}`.replace(/\s/g, '');
      }
    }
  },
  created() {
    document.domain = Config.domain;
    if (this.$route.query.id) {
      project
        .yshLoadDcwj({
          id: this.$route.query.id
        })
        .then(res => {
          let {
            enterprise,
            project,
            questionnaire,
            contractScale
          } = res.data.data;
          project.contractScale = contractScale;
          project.enterpriseName = enterprise.enterpriseName;
          project.price = moneyInt(project.price);
          project.title = questionnaire.title
            ? '问卷标题：' + questionnaire.title
            : '问卷标题：';
          project.url = questionnaire.id
            ? '问卷链接：' + questionnaire.id
            : '问卷链接：';
          this.ruleForm = project;
          this.ruleForm.taskSum ? '' : (this.ruleForm.taskSum = 0);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.preview {
  line-height: 30px;
  color: #fff;
  background: #de750a;
  font-size: 14px;
  margin-bottom: 23px;
}

.copy {
  background: #75c750;
  color: #fff;
}

.button-margin-top {
  margin-top: 77px;

  .el-button {
    border-radius: 2px;
    float: left;

    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
}

//中间背景留白 /对照UI
.academy-addedit-wrap {
  height: 100%;

  > .el-form {
    height: 100%;
  }

  .el-form-item {
    margin-bottom: 20px;

    .el-input {
      /*输入框宽度*/
      width: 224px;

      &.yuan {
        /*输入框后面追加<元>*/
        &:after {
          content: '元';
          margin-left: 10px;
          position: absolute;
        }
      }
    }

    &.input-width {
      /*项目单价和总任务量输入框宽度*/
      .el-input {
        width: 140px;
      }
    }
  }
}
</style>
